module.exports = __webpack_public_path__ + "static/media/virtual-tour-icon.8cf8ad7e.svg";